// extracted by mini-css-extract-plugin
export default {"container":"AssociationsList_container__2XySF","roles":"AssociationsList_roles__cJIGn","team":"AssociationsList_team__X4jr+","title":"AssociationsList_title__wdvxP"};